module.exports = __webpack_public_path__ + "img/short-icon.b8c174ce.svg";